/**
 * Visitor tracking utilities using cookies
 */

const VISITOR_COOKIE_NAME = 'lavenir_visitor_id';
const COOKIE_EXPIRY_DAYS = 365; // 1 year

/**
 * Generate a unique visitor ID
 */
function generateVisitorId(): string {
  return `v_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`;
}

/**
 * Set a cookie
 */
function setCookie(name: string, value: string, days: number): void {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
}

/**
 * Get a cookie value
 */
function getCookie(name: string): string | null {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

/**
 * Get or create visitor ID from cookie
 */
export function getOrCreateVisitorId(): string {
  let visitorId = getCookie(VISITOR_COOKIE_NAME);
  
  if (!visitorId) {
    visitorId = generateVisitorId();
    setCookie(VISITOR_COOKIE_NAME, visitorId, COOKIE_EXPIRY_DAYS);
    console.log('Created new visitor ID:', visitorId);
  } else {
    console.log('Existing visitor ID:', visitorId);
  }
  
  return visitorId;
}

/**
 * Get visitor information to send with connection request
 */
export function getVisitorInfo() {
  const visitorId = getOrCreateVisitorId();
  
  return {
    visitor_id: visitorId,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    language: typeof navigator !== 'undefined' ? navigator.language : undefined,
  };
}
